import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ConfirmationDialog } from '../../../legacy-design-system/modal'
import { PureQueryOptions } from 'apollo-client'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'

export const suppressMutation = gql`
  mutation SuppressAttackEvent($organizationID: ID!, $eventUuid: ID!) {
    suppressAttackEvent(
      input: { organizationID: $organizationID, eventUuid: $eventUuid }
    ) {
      _placeholder
    }
  }
`

export function SuppressDialog({
  isOpen,
  setIsOpen,
  refetchQueries,
  refresh,
  organizationID,
  event: { eventUuid, displayName, sourceIP }
}: {
  readonly organizationID: string
  readonly event: {
    readonly eventUuid: string
    readonly displayName: string
    readonly sourceIP?: string
  }
  readonly refresh: () => Promise<any>
  readonly refetchQueries: PureQueryOptions[]
  readonly isOpen: boolean
  readonly setIsOpen: (isOpen: boolean) => void
}) {
  return (
    <Mutation mutation={suppressMutation}>
      {(suppressEvent) => {
        return (
          <ConfirmationDialog
            size="small"
            isOpen={isOpen}
            onCancel={() => setIsOpen(false)}
            onConfirm={async () => {
              setIsOpen(false)
              await suppressEvent({
                refetchQueries,
                variables: {
                  organizationID,
                  eventUuid
                }
              })
              await refresh()
            }}
            renderTitle={() => (
              <FormattedMessage id="title_attackEvents_suppressEvent" />
            )}
            renderBody={() => {
              if (sourceIP) {
                return (
                  <BodySingleKnown
                    displayName={displayName}
                    source={sourceIP}
                  />
                )
              }
              return <BodySingleUnknown displayName={displayName} />
            }}
            renderConfirmMessage={() => (
              <FormattedMessage id="action_attacks_suppress_attack" />
            )}
            renderCancelMessage={() => <FormattedMessage id="action_cancel" />}
          />
        )
      }}
    </Mutation>
  )
}

function BodySingleKnown({ displayName, source }) {
  return (
    <FormattedMessage
      id="variable_suppressSingleEvent_suppressConfirmation_a_react"
      values={{
        message: (
          <strong>
            <FormattedMessage
              id="variable_suppressSingleEvent_suppressConfirmation_b_react"
              values={{
                eventName: displayName,
                eventSource: source
              }}
            />
          </strong>
        )
      }}
    />
  )
}

function BodySingleUnknown({ displayName }) {
  return (
    <FormattedMessage
      id="variable_suppressSingleEvent_suppressConfirmation_a_react"
      values={{
        message: (
          <strong>
            <FormattedMessage
              id="variable_suppressSingleEvent_suppressConfirmationUnknown_b_react"
              values={{ eventName: displayName }}
            />
          </strong>
        )
      }}
    />
  )
}
